(function () {
  var rebindTimer = null;

  function rebindWayvia() {
    if (window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
      window.PriceSpider.rebind();
    }
  }

  function scheduleRebind() {
    clearTimeout(rebindTimer);
    rebindTimer = setTimeout(rebindWayvia, 100);
  }

  function isUnboundWidget(el) {
    return (
      el &&
      el.nodeType === 1 &&
      el.classList &&
      el.classList.contains('ps-widget') &&
      !el.querySelector('.ps-button-label, small')
    );
  }

  function nodeHasUnboundWidget(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (isUnboundWidget(node)) {
      return true;
    }

    if (!node.querySelectorAll) {
      return false;
    }

    var widgets = node.querySelectorAll('.ps-widget');

    for (var i = 0; i < widgets.length; i++) {
      if (isUnboundWidget(widgets[i])) {
        return true;
      }
    }

    return false;
  }

  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    var widgets = document.querySelectorAll(
      '.product__find-more-retailers .ps-widget, .product__find-more-retailers-embedded.ps-widget'
    );

    if (!widgets.length || !variant) {
      return;
    }

    var sku = variant.barcode || variant.sku || '';

    for (var i = 0; i < widgets.length; i++) {
      widgets[i].setAttribute('ps-sku', sku);
    }

    rebindWayvia();
  });

  // Load more / filter AJAX injects new product cards with unbound .ps-widget shells
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;

        for (var j = 0; j < nodes.length; j++) {
          if (nodeHasUnboundWidget(nodes[j])) {
            scheduleRebind();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Restore scroll position after lightbox is closed
  var scrollBeforeLightbox = null;

  document.addEventListener(
    'click',
    function (evt) {
      if (evt.target.closest && evt.target.closest('.ps-widget[ps-widget-type="lightbox"]')) {
        scrollBeforeLightbox = window.pageYOffset;
      }
    },
    true
  );

  if (typeof MutationObserver !== 'undefined') {
    var lightboxWasOpen = document.body.classList.contains('ps-open');

    new MutationObserver(function () {
      var isOpen = document.body.classList.contains('ps-open');

      if (isOpen === lightboxWasOpen) {
        return;
      }

      lightboxWasOpen = isOpen;

      if (isOpen || scrollBeforeLightbox === null) {
        return;
      }

      var target = scrollBeforeLightbox;
      scrollBeforeLightbox = null;

      requestAnimationFrame(function () {
        window.scrollTo(0, target);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  // Fallback for load-more click timing
  document.addEventListener('click', function (evt) {
    var trigger =
      evt.target.closest &&
      evt.target.closest('.collection__infinite-trigger a, .search__infinite-trigger a');

    if (!trigger) {
      return;
    }

    scheduleRebind();
    setTimeout(scheduleRebind, 500);
    setTimeout(scheduleRebind, 1500);
  });
})();
